import React, { useEffect, useState } from 'react';
import { Map, MapkitProvider, useMap } from 'react-mapkit';
import { ImageHelper } from '../../classes/image-helper.class';
import { IMG_RESIZES } from '../../consts/resizer.consts';
import usePrevious from '../../services/hooks/usePrevious';
import emptySpotImg from '../../assets/img/empty-spot.png';
import annoHover from '../../assets/img/dog-rescues/map-anno-hover.png';
import anno from '../../assets/img/dog-rescues/map-anno.png';

const customAnno = (_, options) => {
    const res = options.data;
    const isActive = res.id == res.activeResId;

    const img = document.createElement('img');
    img.className = 'c-pointer';
    img.src = isActive ? annoHover : anno;
    img.alt = res.rescueName;
    img.width = '42';
    img.height = '50';
    img.loading = 'lazy';

    return img;
};

const calloutDelegate = {
    calloutElementForAnnotation: (anno) => {
        const res = anno.data;
        const { countryRank, state, stateRank, city, cityRank } = res;
        const { top, bottom, left, right } = res.calloutPosition;

        const elementCont = document.createElement('div');
        elementCont.className = `map-spot-callout-res-cont ${top ? 'call-top' : ''} ${bottom ? 'call-bottom' : ''} ${left ? 'call-left' : ''} ${
            right ? 'call-right' : ''
        }`;

        const element = elementCont.appendChild(document.createElement('div'));
        element.className = 'map-spot-callout-res';

        const imgDiv = element.appendChild(document.createElement('div'));
        imgDiv.className = 'map-spot-callout-res__imgDiv';
        const img = imgDiv.appendChild(document.createElement('img'));
        img.src = ImageHelper.getUrlFromOptions(res.logo || emptySpotImg, `fit-in/${IMG_RESIZES.x0256}`);
        img.alt = res.rescueName;
        img.width = '234';
        img.height = '150';
        img.loading = 'lazy';

        const title = element.appendChild(document.createElement('h3'));
        title.className = 'snif-p snif-semibold text-primary mt-1 pt-05 mb-05';
        title.textContent = res.rescueName;

        const cRanks = countryRank ? `#${countryRank} in United States` : '';
        const sRanks = state && stateRank ? `#${stateRank} in ${state}` : '';
        const cityRanks = city && cityRank ? `#${cityRank} in ${city}` : '';
        const ranksArr = [];
        cRanks && ranksArr.push(cRanks);
        sRanks && ranksArr.push(sRanks);
        cityRanks && ranksArr.push(cityRanks);

        const ranks = element.appendChild(document.createElement('div'));
        ranks.className = 'd-flex';

        const rankLogo = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        rankLogo.style = 'position: relative; top: 4px;';
        rankLogo.setAttribute('width', 16);
        rankLogo.setAttribute('height', 16);
        rankLogo.setAttribute('viewBox', '0 0 24 24');
        rankLogo.setAttribute('fill', 'none');

        const svgP1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        svgP1.setAttribute(
            'd',
            'M3.33202 0.0376076C2.59978 0.170088 1.94842 0.70356 1.66712 1.40117C1.50036 1.81471 1.50485 1.75087 1.49412 3.864C1.48157 6.33823 1.506 6.93019 1.6578 7.83101C1.84265 8.92793 2.2662 10.1187 2.82281 11.1062C3.30684 11.965 3.80612 12.6318 4.48721 13.3291C6.1596 15.0412 8.2778 16.1015 10.6528 16.4153C10.8556 16.4421 11.0689 16.464 11.1268 16.464H11.232V17.256V18.048H11.154C10.8705 18.048 9.95789 18.2589 9.444 18.4431C9.03984 18.588 8.34392 18.9302 7.98516 19.1605C6.98948 19.7996 6.14381 20.6689 5.54772 21.6658C5.26889 22.1321 4.94904 22.8421 4.88897 23.1281C4.82048 23.4541 5.03784 23.8279 5.36772 23.9513C5.49831 24.0002 5.50839 24.0002 12.0313 23.9941L18.564 23.988L18.6767 23.9325C18.7387 23.902 18.834 23.8323 18.8886 23.7777C19.0378 23.6285 19.0866 23.5157 19.0985 23.292C19.1079 23.1163 19.1012 23.0796 19.0198 22.86C18.8986 22.5333 18.6369 21.9924 18.4355 21.6528C17.2856 19.7134 15.2063 18.3416 12.996 18.0641L12.756 18.034L12.7497 17.249L12.7434 16.464H12.8609C13.0486 16.464 13.6811 16.3736 14.124 16.2836C15.812 15.9402 17.39 15.1778 18.744 14.0513C19.0595 13.7888 19.6388 13.2186 19.9258 12.888C21.114 11.5194 21.9272 9.87631 22.2836 8.124C22.4881 7.11847 22.5193 6.51931 22.5059 3.864C22.4972 2.1475 22.4919 1.93795 22.4539 1.77622C22.2888 1.07414 21.8249 0.499656 21.1839 0.20352C21.0886 0.159456 20.9245 0.0985916 20.8193 0.0682316L20.628 0.0130556L18.5012 0.00566355C16.4003 -0.00163245 16.3728 -0.00110445 16.2417 0.0479516C15.7285 0.239952 15.587 0.893592 15.9747 1.28129C16.026 1.3326 16.1274 1.4028 16.2 1.43729L16.332 1.5L18.396 1.512C20.7187 1.52551 20.5371 1.50986 20.7569 1.71542C20.8233 1.77754 20.8996 1.88042 20.9314 1.95086L20.988 2.076V4.332C20.988 6.6925 20.9853 6.76968 20.877 7.452C20.6578 8.83322 20.0791 10.2048 19.2361 11.3413C17.9529 13.0711 16.1123 14.2796 14.016 14.7687C13.3683 14.9198 12.7581 14.9854 12 14.9854C11.2419 14.9854 10.6317 14.9198 9.984 14.7687C8.43857 14.4081 7.02204 13.6559 5.88536 12.5921C5.02625 11.7881 4.43753 10.9943 3.92429 9.948C3.47926 9.04075 3.21629 8.1798 3.08489 7.2C3.00941 6.63727 2.99705 6.16243 3.00454 4.116L3.012 2.076L3.0686 1.95086C3.10044 1.88042 3.17669 1.77754 3.2431 1.71542C3.46287 1.50986 3.28126 1.52551 5.604 1.512L7.668 1.5L7.8 1.43729C8.2974 1.20101 8.40255 0.547824 8.00019 0.193656C7.94016 0.140832 7.83238 0.0756476 7.76064 0.0487916C7.63304 0.00105555 7.58544 4.75519e-05 5.57309 0.00215955C3.93084 0.00386355 3.4789 0.0110156 3.33202 0.0376076ZM11.7444 1.52347C11.4299 1.58054 11.1239 1.77221 10.9285 2.03462C10.8766 2.10425 10.5922 2.63616 10.2965 3.21662L9.75888 4.272H8.86786C8.34039 4.272 7.91871 4.28246 7.83442 4.29766C7.6136 4.33742 7.31866 4.49093 7.15599 4.65077C6.7376 5.06184 6.63468 5.66138 6.88839 6.20976C6.95751 6.35918 7.03318 6.44122 7.84616 7.24807L8.7289 8.12417L8.30033 9.10807C7.71917 10.4424 7.76751 10.3035 7.76561 10.644C7.76427 10.8863 7.77291 10.9578 7.82009 11.0944C7.95644 11.4891 8.27811 11.8037 8.688 11.9431C8.8848 12.01 9.34623 12.0044 9.528 11.9328C9.6006 11.9042 10.1866 11.5846 10.8301 11.2226L12.0003 10.5643L13.1062 11.1868C13.7145 11.5292 14.2651 11.8361 14.3299 11.8689C14.6983 12.0556 15.2187 12.0351 15.5867 11.8195C15.8532 11.6633 16.0793 11.3868 16.1795 11.0944C16.2243 10.9636 16.2352 10.8806 16.2356 10.668C16.2361 10.3354 16.244 10.3584 15.6996 9.1093L15.2713 8.12662L16.1536 7.2493C16.9426 6.46476 17.0437 6.35551 17.1101 6.216C17.4051 5.59613 17.2196 4.884 16.6668 4.51428C16.3347 4.29216 16.3098 4.28813 15.199 4.27747L14.234 4.26821L13.9542 3.7121C13.1791 2.1715 13.1344 2.0915 12.9374 1.89583C12.722 1.68185 12.5163 1.57104 12.2444 1.52256C12.0227 1.48301 11.9668 1.48313 11.7444 1.52347ZM11.4146 4.34426C10.7936 5.56565 10.7691 5.60328 10.5162 5.72014C10.4088 5.76977 10.3634 5.7725 9.45792 5.784L8.51184 5.796L9.36936 6.63598C10.3488 7.59535 10.3718 7.62538 10.3708 7.93978C10.3702 8.14198 10.3897 8.09011 9.84418 9.3408C9.46085 10.2196 9.44288 10.2676 9.50957 10.2331C9.54836 10.2131 10.0509 9.93166 10.6263 9.60775C11.2018 9.28385 11.7152 9.00379 11.7673 8.98541C11.8819 8.94502 12.1067 8.94194 12.2184 8.97926C12.2633 8.99426 12.8 9.28716 13.4111 9.63014C14.0222 9.97313 14.5272 10.2489 14.5332 10.2429C14.5392 10.2368 14.3701 9.83326 14.1574 9.34596C13.6183 8.1109 13.6298 8.14161 13.6292 7.93987C13.6282 7.62624 13.6517 7.59562 14.6311 6.636L15.4884 5.796L14.5422 5.784C13.6366 5.7725 13.5912 5.76977 13.4838 5.72014C13.2296 5.60268 13.2048 5.56462 12.5845 4.34354C12.2696 3.72374 12.0066 3.21655 12 3.21646C11.9934 3.21636 11.73 3.72389 11.4146 4.34426ZM11.34 19.5386C9.54586 19.7581 7.99596 20.7019 7.01348 22.1731L6.81118 22.476L11.9775 22.482C14.819 22.4854 17.1488 22.4832 17.1549 22.4771C17.1714 22.4606 17.0502 22.2623 16.8756 22.02C16.364 21.3099 15.7027 20.7138 14.9645 20.2973C14.2295 19.8826 13.5347 19.6528 12.696 19.5472C12.3954 19.5093 11.6197 19.5044 11.34 19.5386Z'
        );
        svgP1.setAttribute('fill', '#787878');
        svgP1.setAttribute('fill-rule', 'evenodd');
        svgP1.setAttribute('clip-rule', 'evenodd');
        rankLogo.appendChild(svgP1);
        ranks.appendChild(rankLogo);

        const rankText = ranks.appendChild(document.createElement('p'));
        rankText.className = 'snif-s1 text-medium ps-1';
        rankText.style = 'width: calc(100% - 16px)';
        rankText.textContent = ranksArr.join(', ');

        if (res.specializations.length > 0) {
            const spec = element.appendChild(document.createElement('div'));
            spec.className = 'map-spot-callout-res__specs';

            res.specializations.forEach((s) => {
                const specComp = spec.appendChild(document.createElement('div'));
                specComp.textContent = s;
            });
        }

        element.onclick = (e) => res.handleClick(e);

        return elementCont;
    },
    calloutAnchorOffsetForAnnotation: () => new DOMPoint(0, 0),
};

const getBoundRect = (map) => {
    const mapBoundRect = map.region.toBoundingRegion();
    const data = {
        ne: {
            lat: mapBoundRect.northLatitude,
            lng: mapBoundRect.eastLongitude,
        },
        sw: {
            lat: mapBoundRect.southLatitude,
            lng: mapBoundRect.westLongitude,
        },
    };
    return data;
};

const getCenter = (map) => {
    const latlng = map.center;
    const data = {
        lat: latlng.latitude,
        lng: latlng.longitude,
    };
    return data;
};

const RenderMap = ({ center, cameraDistance, activeResId, filteredRescues, setMapRect }) => {
    const prevCenter = usePrevious(center);
    const [loading, setLoading] = useState(false);

    const { map, mapProps, mapkit } = useMap({
        center: [center.latitude, center.longitude],
        showsCompass: 'hidden',
        cameraDistance,
    });

    const handleClickAnno = (res) => window.open(res.slug, '_blank');

    useEffect(() => {
        if (map && mapkit) {
            !loading && setMapRect(getBoundRect(map));
            map.addEventListener('zoom-end', () => setMapRect(getBoundRect(map)));
            map.addEventListener('scroll-end', () => setMapRect(getBoundRect(map)));
        }
    }, [map, mapkit]);

    useEffect(() => {
        if (map && mapkit && center?.longitude && center?.latitude) {
            if (prevCenter.latitude !== center.latitude || prevCenter.longitude !== center.longitude) {
                map.setCenterAnimated(new mapkit.Coordinate(center.latitude, center.longitude), false);
                map.setCameraDistanceAnimated(cameraDistance, false);
            }
        }
    }, [map, mapkit, prevCenter, center]);

    useEffect(() => {
        if (map && map.center && mapkit && !loading && filteredRescues && filteredRescues.length > 1) {
            const sortedLat = [...filteredRescues].sort((a, b) => a.latitude - b.latitude);
            const sortedLng = [...filteredRescues].sort((a, b) => a.longitude - b.longitude);

            if (!sortedLat[0].latitude || !sortedLng[0].longitude) {
                return;
            }

            const lowestLat = map.center.latitude - sortedLat[0].latitude;
            const highestLat = sortedLat[sortedLat.length - 1].latitude - map.center.latitude;
            const lowestLng = map.center.longitude - sortedLng[0].longitude;
            const highestLng = sortedLng[sortedLng.length - 1].longitude - map.center.longitude;
            const latSpan = (lowestLat > highestLat ? lowestLat : highestLat) * 2 * 1.35;
            const lngSpan = (lowestLng > highestLng ? lowestLng : highestLng) * 2 * 1.35;
            const spanCoor = new mapkit.CoordinateSpan(latSpan, lngSpan);
            setLoading(true);
            setTimeout(() => {
                map.setRegionAnimated(new mapkit.CoordinateRegion(map.center, spanCoor));
            }, 400);
            setTimeout(() => setLoading(false), 1000);
        }
    }, [map, mapkit, filteredRescues]);

    useEffect(() => {
        if (map && mapkit && !loading && filteredRescues) {
            map.removeAnnotations(map.annotations);

            if (filteredRescues.length > 0) {
                const newMarkers = [];

                filteredRescues.forEach((res) => {
                    if (!res.latitude || !res.longitude) {
                        return;
                    }

                    const isActive = res.id == activeResId;
                    const mapCenter = getCenter(map);
                    let top = false;
                    let left = false;
                    let right = false;
                    let bottom = false;

                    if (parseFloat(res.latitude) > mapCenter.lat) {
                        top = true;
                    } else {
                        bottom = true;
                    }

                    if (parseFloat(res.longitude) > mapCenter.lng) {
                        right = true;
                    } else {
                        left = true;
                    }

                    const calloutPosition = { top, bottom, left, right };

                    const options = {
                        callout: calloutDelegate,
                        data: {
                            ...res,
                            activeResId,
                            calloutPosition,
                            handleClick: () => handleClickAnno(res),
                        },
                        selected: isActive,
                        calloutEnabled: !isActive,
                    };

                    const coordinate = new mapkit.Coordinate(parseFloat(res.latitude), parseFloat(res.longitude));
                    const annotation = new mapkit.Annotation(coordinate, customAnno, options);
                    newMarkers.push(annotation);
                });
                map.addAnnotations(newMarkers);
            }
        }
    }, [map, mapkit, activeResId, filteredRescues]);

    return <Map {...mapProps} />;
};

const SniffAppleMapsRescue = (props) => {
    if (!props.mapkitToken) {
        return '';
    }

    return (
        <MapkitProvider tokenOrCallback={props.mapkitToken} showsZoomControl>
            <RenderMap {...props} />
        </MapkitProvider>
    );
};

export default SniffAppleMapsRescue;
